import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, ControlContainer } from '@angular/forms';

@Component({
  selector: 'blood-pressure-form',
  templateUrl: './blood-pressure-form.component.html',
  styles: []
})
export class BloodPressureFormComponent implements OnInit {
  @Input() parent: FormGroup;
  @Input() isRequired: boolean;
  blockIndex: number = 1;

  public bloodPressureFormGroup: FormGroup;
  formGroupParent: any;

  constructor(private controlContainer: ControlContainer) { }

  ngOnInit() {
    this.bloodPressureFormGroup = <FormGroup>this.controlContainer.control;
    this.formGroupParent = this.controlContainer.name;
  }

}
